export default function MainGrid({ children }: { children: React.ReactNode }) {
  return (
    <div className="w-full overflow-x-auto lg:overflow-visible">
      <div className="grid gap-5 grid-flow-row grid-cols-1 lg:grid-flow-col lg:grid-cols-3">
        {children}
      </div>
    </div>
  );
}
